import React from "react";
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  description?: string;
  align?: "left" | "center";
  dark?: boolean;
};
export function SectionHeading({
  eyebrow,
  title,
  description,
  align = "center",
  dark = false
}: SectionHeadingProps) {
  const alignment = align === "center" ? "mx-auto text-center" : "text-left";
  return <div className={`max-w-3xl ${alignment}`} data-id="element-10" data-mp="3k203paisxe6s">
      {eyebrow && <p className={`mb-3 text-xs font-extrabold uppercase tracking-[0.16em] ${dark ? "text-[#FFD56A]" : "text-[#E93670]"}`} data-id="element-11" data-mp="bloirbrnmi6q">
          {eyebrow}
        </p>}
      <h2 className={`font-display text-3xl leading-[1.04] tracking-[-0.04em] sm:text-4xl lg:text-5xl ${dark ? "text-white" : "text-[#172A4A]"}`} data-id="element-12" data-mp="1utu60qxr6i4">
        {title}
      </h2>
      {description && <p className={`mt-5 text-base leading-7 sm:text-lg ${dark ? "text-white/75" : "text-[#52617a]"}`} data-id="element-13" data-mp="uj7w2rl5amyy">
          {description}
        </p>}
    </div>;
}